import { render } from "./GOAL_REACHED.vue?vue&type=template&id=37d50310&scoped=true&ts=true"
import script from "./GOAL_REACHED.vue?vue&type=script&lang=ts"
export * from "./GOAL_REACHED.vue?vue&type=script&lang=ts"

import "./GOAL_REACHED.vue?vue&type=style&index=0&id=37d50310&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d50310"]])

export default __exports__